'use strict';
angular.module('resourceMultiImgsUploaderModule', []).
controller('resourceMultiImgsUploaderCtrl', ["$scope", "$timeout", "$modalInstance", "$q", "$modal", "$filter", "trsHttpService", "modalDialog", "specialCase",
    function($scope, $timeout, $modalInstance, $q, $modal, $filter, trsHttpService, modalDialog, specialCase) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                lockBtn: false,
            };
            $scope.data = {
                uploadImgs: [],
                uploadedSrcs: [],
                progress: {}
            };
        }
        /**
         
         * @return {[type]} [description]
         */
        function initData() {
            $scope.callBack = {
                success: function(file, src, uploader) {
                    getuploaderData(src, file).then(function(data) {
                        if (data.length === $scope.data.uploadImgs.length) {
                            data.sort(function(x, y) {
                                return x.APPSORT > y.APPSORT ? 1 : -1;
                            });
                            angular.forEach(data, function(value, key) {
                                delete value.APPSORT;
                            });
                            $modalInstance.close(data);
                        }
                    }, function(data) {
                        modalDialog.alertType("图片上传失败", "请稍后再试", "error", false, function() {
                            $modalInstance.dismiss();
                        });
                    });
                },
                error: function(file) {
                    //$modalInstance.dismiss();
                },
                file: function(file, uploader) {
                    // console.log(file);
                    angular.forEach(file, function(value, key) {
                        uploader.makeThumb(value, function(error, src) {
                            $timeout(function() {
                                $scope.data.uploadImgs.push({
                                    src: src,
                                    id: value.id
                                });
                            }, 200);
                        });
                    });

                    $scope.finish = function() {
                        $scope.status.lockBtn = true;
                        uploader.upload();
                    };
                },
                tar: function(file, percentage) {

                    var per = Math.ceil(percentage * 100) + "%";
                    $timeout(function() {
                        $scope.data.progress[file.id] = per;
                    });
                },
                comp: function(file) {

                }
            };
        }
        /**
         * [getuploaderData description]获得图片上传后的路径和文件名
         * @param  {[ob]} src  [description]图片上传后的地址
         * @param  {[obj]} file [description]图片队列
         * @return {[type]}      [description]
         */
        function getuploaderData(src, file) {
            var deferred = $q.defer();
            if (angular.isDefined(specialCase) && specialCase == 'historyPic') {
                var picUrl = src.imgSrc.indexOf("ScaleWidth=600")>-1 ? src.imgSrc.replace("ScaleWidth=600&", "") : src.imgSrc;
                var params = {
                    serviceid: "tpg",
                    modelid: "uploadByUrl",
                    typeid: "zyzx",
                    url: picUrl,
                    type: file.ext
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    if (data === "") {
                        deferred.reject();
                    } else {
                        data.HEIGHT = data.HEIGHT.toString();
                        data.WIDTH = data.WIDTH.toString();
                        $scope.data.uploadedSrcs.push({
                            'FIRST_PICTURE': '0',
                            'PERPICURL': data.PERPICURL,
                            'F_S_LINK': data.F_S_LINK,
                            'ORDERNUM': '0',
                            'APPDESC': file.name.replace(/\.\w+$/, ''),
                            'HEIGHT': data.HEIGHT,
                            'ISDELETE': "0",
                            'SRC_LINK': src.imgName,
                            'CREATETIME': $filter('date')(new Date(), "yyyy/MM/dd HH:mm:ss").toString(),
                            'SRCPICURL': data.SRCPICURL,
                            'PIC_ID': data.PIC_ID,
                            'WIDTH': data.WIDTH
                        });
                        deferred.resolve($scope.data.uploadedSrcs);
                    }
                }, function() {
                    deferred.reject();
                });
            } else {
                $scope.data.uploadedSrcs.push({
                    'PERPICURL': src.imgSrc,
                    'APPFILE': src.imgName,
                    'APPDESC': file.name.replace(/\.\w+$/, ''),
                    'APPSORT': file.id.substr(file.id.length - 1, 1)
                });
                deferred.resolve($scope.data.uploadedSrcs);
            }
            return deferred.promise;
        }
        $scope.close = function() {
            $modalInstance.dismiss('cancel');
        };
    }
]);
